// src/utils/karateCategories.js

/* =========================
   Catégories de poids Karaté
   Saison 2025-2026
   ========================= */

export const weightCategories = {
  /* =========================
     Jeunes / Adultes Masculins
     ========================= */

  // Avant Mini-poussins : hors tableau officiel, affichage en groupes morphologiques
  Eveil: ["Groupes Morphologiques"],

  MiniPoussin: ["-25", "-35", "+35 kg"],
  Poussin: ["-25", "-35", "+35 kg"],
  Pupille: ["-25", "-30", "-35", "-40", "-45", "-50", "+50 kg"],
  Benjamin: ["-30", "-35", "-40", "-45", "-50", "-55", "+55 kg"],
  Minime: ["-35", "-40", "-45", "-50", "-55", "-60", "-65", "+65 kg"],
  Cadet: ["-52", "-57", "-63", "-70", "+70 kg"],
  Junior: ["-55", "-61", "-68", "-76", "+76 kg"],
  Espoir: ["-60", "-67", "-75", "-84", "+84 kg"],
  Sénior: ["-60", "-67", "-75", "-84", "+84 kg"],

  /* =========================
     Jeunes / Adultes Féminines
     ========================= */

  EveilF: ["Groupes Morphologiques"],

  MiniPoussinF: ["-25", "-35", "+35 kg"],
  PoussinF: ["-25", "-35", "+35 kg"],
  PupilleF: ["-25", "-30", "-35", "-40", "-45", "+45 kg"],
  BenjaminF: ["-30", "-35", "-40", "-45", "-50", "+50 kg"],
  MinimeF: ["-35", "-40", "-45", "-50", "-55", "+55 kg"],
  CadetF: ["-47", "-54", "-61", "+61 kg"],
  JuniorF: ["-48", "-53", "-59", "-66", "+66 kg"],
  EspoirF: ["-50", "-55", "-61", "-68", "+68 kg"],
  SéniorF: ["-50", "-55", "-61", "-68", "+68 kg"],

  /* =========================
     Vétérans Masculins
     ========================= */

  M1: ["-67", "-75", "-84", "+84 kg"],
  M2: ["-67", "-75", "-84", "+84 kg"],
  M3: ["-67", "-75", "-84", "+84 kg"],
  M4: ["-67", "-75", "-84", "+84 kg"],
  M5: ["-67", "-75", "-84", "+84 kg"],

  /* =========================
     Vétérans Féminines
     ========================= */

  F1: ["-55", "-61", "-68", "+68 kg"],
  F2: ["-55", "-61", "-68", "+68 kg"],
  F3: ["-55", "-61", "-68", "+68 kg"],
  F4: ["-55", "-61", "-68", "+68 kg"],
  F5: ["-55", "-61", "-68", "+68 kg"],
};

/* =========================
   Helpers SAISON
   ========================= */

export const getCurrentSeasonStartYear = (d = new Date()) => {
  const y = d.getFullYear();
  const m = d.getMonth(); // saison commence au 1er août
  return m >= 7 ? y : y - 1;
};

export const seasonStringFromStartYear = (startYear) =>
  `${startYear}-${startYear + 1}`;

export const parseSeasonStartYear = (s) => {
  if (!s) return getCurrentSeasonStartYear();
  const value = parseInt(String(s).split("-")[0], 10);
  return Number.isNaN(value) ? getCurrentSeasonStartYear() : value;
};

/* =========================
   Tranches d’âge Karaté
   Basées sur l’année de naissance
   Exemple saison 2025-2026 :
   - Mini poussins : 2021 - 2020
   - Poussins : 2019 - 2018
   - Pupilles : 2017 - 2016
   ========================= */

export const AGE_BANDS = [
  {
    key: "Eveil",
    labelM: "Eveil",
    labelF: "Eveil",
    minAge: 0,
    maxAge: 3,
  },
  {
    key: "MiniPoussin",
    labelM: "Mini poussin",
    labelF: "Mini poussine",
    minAge: 4,
    maxAge: 5,
  },
  {
    key: "Poussin",
    labelM: "Poussin",
    labelF: "Poussine",
    minAge: 6,
    maxAge: 7,
  },
  {
    key: "Pupille",
    labelM: "Pupille",
    labelF: "Pupille",
    minAge: 8,
    maxAge: 9,
  },
  {
    key: "Benjamin",
    labelM: "Benjamin",
    labelF: "Benjamine",
    minAge: 10,
    maxAge: 11,
  },
  {
    key: "Minime",
    labelM: "Minime",
    labelF: "Minime",
    minAge: 12,
    maxAge: 13,
  },
  {
    key: "Cadet",
    labelM: "Cadet",
    labelF: "Cadette",
    minAge: 14,
    maxAge: 15,
  },
  {
    key: "Junior",
    labelM: "Junior",
    labelF: "Junior",
    minAge: 16,
    maxAge: 17,
  },
  {
    key: "Espoir",
    labelM: "Espoir",
    labelF: "Espoir",
    minAge: 18,
    maxAge: 20,
  },
  {
    key: "Sénior",
    labelM: "Sénior",
    labelF: "Sénior",
    minAge: 21,
    maxAge: 34,
  },
];

export const VETERANS = [
  {
    keyM: "M1",
    keyF: "F1",
    minAge: 35,
    maxAge: 45,
    label: "Vétéran 1",
  },
  {
    keyM: "M2",
    keyF: "F2",
    minAge: 46,
    maxAge: 55,
    label: "Vétéran 2",
  },
  {
    keyM: "M3",
    keyF: "F3",
    minAge: 56,
    maxAge: 65,
    label: "Vétéran 3",
  },
  {
    keyM: "M4",
    keyF: "F4",
    minAge: 66,
    maxAge: 75,
    label: "Vétéran 4",
  },
  {
    keyM: "M5",
    keyF: "F5",
    minAge: 76,
    maxAge: Infinity,
    label: "Vétéran 5",
  },
];

/* =========================
   Génération des années de naissance
   Pour le karaté, on se base sur l’âge dans l’année de début de saison.
   Exemple saison 2025-2026 :
   âge 4-5 ans => nés en 2021 - 2020
   ========================= */

export const yearRange = (seasonStartYear, minAge, maxAge) => {
  if (maxAge === Infinity) {
    const fromYear = seasonStartYear - minAge;
    return `${fromYear} et avant`;
  }

  const recentYear = seasonStartYear - minAge;
  const oldYear = seasonStartYear - maxAge;

  if (recentYear === oldYear) {
    return `${recentYear}`;
  }

  return `${recentYear} - ${oldYear}`;
};

export const buildCategoriesForSeason = (seasonStr) => {
  const startYear = parseSeasonStartYear(seasonStr);
  const rows = [];

  AGE_BANDS.forEach(({ key, labelM, labelF, minAge, maxAge }) => {
    const annees = yearRange(startYear, minAge, maxAge);

    rows.push({
      label: labelM,
      annees,
      ageCategory: key,
      genre: "Masculin",
    });

    rows.push({
      label: labelF,
      annees,
      ageCategory: `${key}F`,
      genre: "Féminin",
    });
  });

  VETERANS.forEach(({ keyM, keyF, minAge, maxAge, label }) => {
    const annees = yearRange(startYear, minAge, maxAge);

    rows.push({
      label,
      annees,
      ageCategory: keyM,
      genre: "Masculin",
    });

    rows.push({
      label,
      annees,
      ageCategory: keyF,
      genre: "Féminin",
    });
  });

  return rows;
};

/* =========================
   Calculs d’affectation
   ========================= */

/**
 * Pour le karaté, on calcule ici l’âge par rapport à l’année de début de saison.
 * Exemple :
 * saison 2025-2026
 * né en 2021 => 4 ans => Mini poussin
 */
export const getAgeAtStartOfSeason = (dobStr, seasonStr) => {
  if (!dobStr) return null;

  const startYear = parseSeasonStartYear(seasonStr);
  const birthYear = new Date(dobStr).getFullYear();

  if (Number.isNaN(startYear) || Number.isNaN(birthYear)) {
    return null;
  }

  return startYear - birthYear;
};

/**
 * Alias conservé pour éviter de casser les imports existants.
 * Même si le nom dit "EndOfSeason", pour le karaté on utilise la logique
 * des années de naissance du tableau.
 */
export const getAgeAtEndOfSeason = (dobStr, seasonStr) => {
  return getAgeAtStartOfSeason(dobStr, seasonStr);
};

export const getAgeCategoryKey = (age, genre) => {
  if (age == null || Number.isNaN(age)) return null;

  const isFemale = genre === "Féminin";

  // Vétérans karaté
  if (age >= 76) return isFemale ? "F5" : "M5";
  if (age >= 66) return isFemale ? "F4" : "M4";
  if (age >= 56) return isFemale ? "F3" : "M3";
  if (age >= 46) return isFemale ? "F2" : "M2";
  if (age >= 35) return isFemale ? "F1" : "M1";

  let baseKey = null;

  for (const band of AGE_BANDS) {
    const inBand =
      age >= band.minAge &&
      (band.maxAge === Infinity || age <= band.maxAge);

    if (inBand) {
      baseKey = band.key;
      break;
    }
  }

  if (!baseKey) return null;

  return isFemale && weightCategories[`${baseKey}F`]
    ? `${baseKey}F`
    : baseKey;
};

const parseKg = (value) => {
  const match = String(value).match(/\d+/);
  return match ? parseInt(match[0], 10) : null;
};

export const isMorpho = (ageKey) => {
  const list = weightCategories[ageKey] || [];
  return list.includes("Groupes Morphologiques");
};

/**
 * Retourne un bracket lisible.
 *
 * Exemples :
 * - Catégories officielles : "-35", "-68", "+84 kg"
 * - Morphologiques : "23 kg", "24 kg", etc.
 */
export const getWeightBracket = (ageKey, poids) => {
  const list = weightCategories[ageKey] || [];

  if (!list.length) return null;

  const numericWeight = Number(poids);

  if (!Number.isFinite(numericWeight) || numericWeight <= 0) {
    return null;
  }

  // Morphologique : clé dynamique par poids réel
  if (isMorpho(ageKey)) {
    return `${numericWeight} kg`;
  }

  // Catégories officielles
  for (const entry of list) {
    if (entry.startsWith("-")) {
      const limit = parseKg(entry);

      if (limit != null && numericWeight < limit) {
        return entry;
      }
    }
  }

  const plus = list.find((entry) => entry.startsWith("+"));

  return plus || null;
};